export const decimalValue = RegExp(/^\d+(\.\d+)?$/);